import { withStyles } from "@material-ui/core";

const styles = () => ({
    "@global": {
        /**
         * Disable the focus outline, which is default on some browsers like
         * chrome when focusing elements
         */
        "*:focus": {
            outline: 0,
        },
        "#root": {
            height: "100%",
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
        },
        "a, a:hover, a:active": {
            textDecoration: "none",
        },
    },
});

function globalStyles() {
    return null;
}

export default withStyles(styles, { withTheme: true })(globalStyles);
